<template>
  <div class="config-form-content adminWeeducAdvanced weeduc-admin-config">
    <div class="content-wrapper primary">
      <div class="wrapper-inner">
        <div class="content-text">
        </div>
        <div class="content-form" >
          <div class="main-container" v-if="hasReady">
            <div class="container-form">
              <div class="form-group-container">
                <v-select
                  v-model="typeLayoutPortalEcommerce"
                  :items="themeOptions"
                  item-title="text"
                  item-value="value"
                  label="Tema Loja Virtual"
                  variant="outlined"
                  class="filter-form-control"
                  density="compact"
                  hide-details
                  style="min-width: 160px;"
                />
                <small class="text-muted">Tema padrão para a loja virtual</small>
                <div class="theme-description mt-2">
                  <p class="mb-1">
                    <strong>Clean:</strong> Tema com design minimalista e cores claras, proporcionando uma experiência visual leve e moderna. Ideal para uma aparência profissional e clean.
                  </p>
                  <p class="mb-0">
                    <strong>Dark:</strong> Tema com fundo escuro e elementos contrastantes, oferecendo uma experiência visual moderna e sofisticada. Reduz o cansaço visual em ambientes com pouca luz.
                  </p>
                </div>
              </div>
              
              <div class="form-group-container">
                <label class="label-form">CSS</label>
                <textarea 
                  class="form-control textarea" 
                  v-model="css" 
                  rows="6"
                  placeholder="<style>...</style>"
                ></textarea>
                <small class="text-muted">CSS personalizado para a loja virtual</small>
                <small class="small alert">Atenção: O CSS personalizado pode causar problemas com o funcionamento do site, use com cuidado.</small>
                </div>  

                <div class="form-group-container" style="margin-top: 15px!important;">
                  <v-select
                    v-model="contentWarning"
                    :items="contentWarningOptions"
                    item-title="text"
                    item-value="value"
                    label="Aviso de Conteúdo Sensível"
                    variant="outlined"
                    class="filter-form-control"
                    density="compact"
                    hide-details
                    style="min-width: 160px;"
                  />
                  <small class="text-muted">Exibir aviso de conteúdo sensível no site</small>
                </div>
            </div>

            <div class="container-form">
              <div class="form-group-container">
                <v-select
                  v-model="typeLayoutPortalStudent"
                  :items="themeOptions"
                  item-title="text"
                  item-value="value"
                  label="Tema Portal do Aluno"
                  variant="outlined"
                  class="filter-form-control"
                  density="compact"
                  hide-details
                  style="min-width: 160px;"
                />
                <small class="text-muted">Tema padrão para o portal do aluno</small>
                <div class="theme-description mt-2">
                    <p class="mb-1">
                      <strong>Clean:</strong> Tema com design minimalista e cores claras, proporcionando uma experiência visual leve e moderna. Ideal para uma aparência profissional e clean.
                    </p>
                    <p class="mb-0">
                      <strong>Dark:</strong> Tema com fundo escuro e elementos contrastantes, oferecendo uma experiência visual moderna e sofisticada. Reduz o cansaço visual em ambientes com pouca luz.
                    </p>
                  </div>
              </div>

              <div class="form-group-container">
                <label class="label-form">JS</label>
                <textarea 
                  class="form-control textarea" 
                  v-model="js" 
                  rows="6"
                  placeholder="<script>...</script>"
                ></textarea>
                <small class="text-muted">JS personalizado para o portal do aluno</small>
                <small class="small alert">Atenção: O JS personalizado pode causar problemas com o funcionamento do site, use com cuidado.</small>
              </div>
            </div>
          </div>
        </div>
        <Loader :isActive="hasReady" />
      </div>
    </div>
    <div class="buttons-container">
          <div class="button">
            <button type="button" class="btn btn-block btn-content" @click="save()" :disabled="loading">
              <span v-if="!loading">Salvar e Publicar</span>
              <div v-else class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
            </button>
            <button type="button" class="btn btn-block btn-content" @click="clearCache()" :disabled="loading">
              <span v-if="!loading">Limpar Cache</span>
              <div v-else class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
            </button>
          </div>
        </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import apiSiteAdvanced from '@/utils/Site/advanced';
import Loader from '@/components/Loader/loader.vue';
import websiteApi from '@/utils/Weflix/website';
import companyApi from '@/utils/company';
// Importação do v-select (assumindo Vuetify ou similar)
import VSelect from 'vuetify/components/VSelect';
import { toast } from 'vue3-toastify';

export default {
  data() {
    return {
      // Ajuste: os valores padrão agora são strings para compatibilidade com o v-select
      typeLayoutPortalEcommerce: '',
      typeLayoutPortalStudent: '',
      contentWarning: '',
      infoCompany: {},
      css: '',
      js: '',
      loading: false,
      hasReady: true,
      themeOptions: [
        { text: 'Selecione uma opção', value: '' },
        { text: 'Dark', value: '0' },
        { text: 'Clean', value: '1' }
      ],
      contentWarningOptions: [
        { text: 'Selecione uma opção', value: '' },
        { text: 'Sim', value: '1' },
        { text: 'Não', value: '0' }
      ]
    };
  },
  computed: {
    ...mapState(['token']),
  },
  components: {
    Loader,
    VSelect
  },
  methods: {
    async getAdvancedData() {
      try {
        const response = await apiSiteAdvanced.getAdvancedData(this.token);
        // Ajuste: garantir que os valores sejam strings para o v-select
        this.typeLayoutPortalEcommerce = response.typeLayout !== undefined && response.typeLayout !== null ? String(response.typeLayout) : '';
        this.typeLayoutPortalStudent = response.typeLayoutPortal !== undefined && response.typeLayoutPortal !== null ? String(response.typeLayoutPortal) : '';
        this.contentWarning = response.contentWarning !== undefined && response.contentWarning !== null ? String(response.contentWarning) : '';
        this.css = response.css || '';
        this.js = response.javascript || '';
        this.hasReady = true;
      } catch (error) {
        toast.error('Erro ao obter dados');
        console.error('Erro ao obter dados avançados:', error);
      }
    },
    async getInfoCompany() {
      try {
        const response = await companyApi.getInfoCompany(this.token);
        this.infoCompany = response;
        this.contentWarning = response.ageRestricted !== undefined && response.ageRestricted !== null ? String(response.ageRestricted) : '';
      } catch (error) {
        toast.error('Erro ao obter dados da empresa');
      }
    },
    async setInfoCompany() {
      try {
        const payload = {
          ...this.infoCompany,
          ageRestricted: this.contentWarning !== '' ? parseInt(this.contentWarning) : null
        };
        const response = await companyApi.setInfoCompany(this.token, payload);
      
        toast.success('Dados da empresa salvos com sucesso!');
      } catch (error) {
        toast.error('Erro ao salvar dados da empresa');
        console.error('Erro ao salvar dados da empresa:', error);
      }
    },
    async save() {
      this.hasReady = false;
      // Ajuste: converter para inteiro antes de enviar para a API
      const payload = {
        typeLayout: this.typeLayoutPortalEcommerce !== '' ? parseInt(this.typeLayoutPortalEcommerce) : null,
        typeLayoutPortal: this.typeLayoutPortalStudent !== '' ? parseInt(this.typeLayoutPortalStudent) : null,
        contentWarning: this.contentWarning !== '' ? parseInt(this.contentWarning) : null,
        css: this.css,
        javascript: this.js,
      }
      try {
        const response = await apiSiteAdvanced.putAdvancedData(this.token, payload);
        if(this.contentWarning !== ''){
          await this.setInfoCompany();
        }
        await this.clearCache();
        await this.getAdvancedData();
        await this.getInfoCompany();
        this.hasReady = true;
        toast.success('Dados avançados salvos com sucesso!');
      } catch (error) {
        toast.error('Erro ao salvar dados avançados');
        console.error('Erro ao salvar dados avançados:', error);
      }
    },
    async clearCache(){
      try {
        const response = await websiteApi.clearCache(this.token);
        this.messageStatusCache = true;
        toast.success('Cache limpo com sucesso!');
      } catch (error) {
        toast.error('Erro ao limpar cache');
        console.error('Erro ao limpar cache', error);
      }
    },
  }, 
  created() {
    this.getAdvancedData();
    this.getInfoCompany();
  }
}
</script>

<style scoped>
@import '@/css/weeduc/admin/advanced.css';
</style>
